export default {
    header: 'מחיר לתשלום',
    paidToDate: 'שולם עד כה',
    paymentsHistory: 'היסטוריית תשלומים',
    paymentsNotes: 'הערות לתשלום',
    updatePaymentsNotes: 'לעדכן את החשבון לתשלום',
    totalDeposit: 'תשלומים',
    noDepositYet: 'לא שולמה מקדמה',
    noPaymentNotes: 'הערות לתשלום',
    actions: {
        addPayment: 'הוספת תשלום',
        addNote: 'הוספת\\עריכת הערה',
        adjustPayment: 'עידכון תשלום',
    },
    validation: {
        requiredNumber: "אנא הזן מספר תקין",
        nonNegative: "הערך חייב להיות 0 או גדול יותר"
    }
}
